import { observer } from 'mobx-react';
import React, { HTMLAttributes } from 'react';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { ShowableCartSourceModeEnum } from 'ReactApp/Types/enum';

type CartSubmitButtonV1Props = HTMLAttributes<HTMLAnchorElement> & {
    href?: string,
    label?: string,
    classes?: string[],
}

const CartSubmitButtonV1 = observer((props: CartSubmitButtonV1Props) => {

    let classes = ['button-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    const orderProcessingHandler = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (showableCartInstance.isOrderBeingProcessed === true) {
            return;
        }

        switch (showableCartInstance.sourceMode) {
            case ShowableCartSourceModeEnum.order:
                await showableCartInstance.updateOrder().then(stat => {
                    // ...
                })
                .catch(err => {
                    showableCartInstance.scrollToOrderErrorBlock();
                });
            break;
            case ShowableCartSourceModeEnum.preOrder:
                await showableCartInstance.createOrder().then(stat => {
                    // ...
                })
                .catch(err => {
                    showableCartInstance.scrollToOrderErrorBlock();
                });
            break;
        }

    }

    return (
        <a 
            className={
                showableCartInstance.isOrderBeingProcessed 
                    ? classes.concat(['_disabled']).join(' ') 
                    : classes.join(' ')
            }
            href={props.href as string}
            onClick={orderProcessingHandler}
            style={Object.assign(
                {
                    width: '18.6rem',
                },
                props.style ?? {}
            )}
            >
            {
                showableCartInstance.isOrderBeingProcessed
                    ? 'Оформляем...'
                    : props.label as string
            }
        </a>
    );

})

export default CartSubmitButtonV1;